var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.62,
    height: 11.668,
    viewBox: "0 0 13.62 11.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3660",
    "data-name": "Group 3660",
    transform: "translate(-207.793 -221.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32498",
    "data-name": "Path 32498",
    d: "M215.137,232.455a3.517,3.517,0,0,1-2.94-5.435l1.554-2.388a.536.536,0,1,1,.9.585l-1.554,2.388a2.444,2.444,0,1,0,4.1,2.667l2.478-3.806a2.445,2.445,0,0,0-.716-3.381,2.456,2.456,0,0,0-2.448-.128.536.536,0,1,1-.488-.954,3.516,3.516,0,0,1,4.55,5.047l-2.478,3.806a3.524,3.524,0,0,1-2.953,1.6Z",
    transform: "translate(0.275 0)",
    fill: "#081e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32499",
    "data-name": "Path 32499",
    d: "M211.312,233.231a3.514,3.514,0,0,1-2.948-5.432l2.477-3.806a3.516,3.516,0,0,1,5.894,3.836l-1.554,2.388a.536.536,0,1,1-.9-.585l1.554-2.388a2.444,2.444,0,1,0-4.1-2.665l-2.477,3.8a2.445,2.445,0,0,0,3.164,3.509.536.536,0,1,1,.488.954A3.52,3.52,0,0,1,211.312,233.231Z",
    transform: "translate(0 0.056)",
    fill: "#081e64"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.619d9e59864b0b09136ddeaa1b5977ee.svg";
export { ForwardRef as ReactComponent };